import React, { ChangeEvent } from 'react';
import { Field, FieldInputProps } from 'react-final-form';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';
import { FormControlLabel, makeStyles, Typography, Checkbox } from 'housecall-ui';

import { PaymentFormFieldName, PaymentFormFields } from './types';
import { useOnlineBookingReducer } from '../../state/useOnlineBookingReducer';
import { useOrgData } from '../../hooks/useOrgData';
import { trackButtonClicked } from '../../hooks/useEventTracking';

const useStyles = makeStyles((theme: HCPTheme) => ({
  checkbox: {
    marginBottom: 'auto',
    padding: `0 ${theme.spacing(1)}px`,
  },
}));

export const SaveCardOnFileField = () => {
  const { checkbox } = useStyles();
  const {
    state: { token },
  } = useOnlineBookingReducer();
  const { data } = useOrgData({ token });

  const onChange =
    (input: FieldInputProps<keyof PaymentFormFields, HTMLElement>) => (event: ChangeEvent<HTMLInputElement>) => {
      input.onChange(event.target.checked);
      trackButtonClicked({
        buttonName: 'ob_save_card_on_file',
        buttonLabel: event.target.checked ? 'enabled' : 'disabled',
      });
    };

  return (
    <Field<PaymentFormFieldName> name="saveCard">
      {({ input, meta }) => {
        const hasError = meta.touched && meta.error;
        return (
          <>
            <FormControlLabel
              data-testid="save-card"
              control={
                <Checkbox
                  required
                  className={checkbox}
                  value="save_card"
                  checked={input.checked}
                  onChange={onChange(input)}
                />
              }
              label={
                <Typography color={hasError ? 'error' : 'initial'}>
                  Save card on file
                  <Typography variant="body2" color={hasError ? 'error' : 'textSecondary'}>
                    I authorize {data?.name} to save and charge my card above for agreed upon future purchases.
                  </Typography>
                </Typography>
              }
            />
          </>
        );
      }}
    </Field>
  );
};
